import React from 'react';
import TextField from 'material-ui/TextField';
import { grey300, grey500, red500, orange500 } from 'material-ui/styles/colors';

const Text = props => {
  const { input, label, helperText, meta, errorText, style, ...custom } = props;
  const { touched, error, warning } = meta || {};

  const err = errorText || (touched && error);
  const warn = touched && warning;
  const cProps = {
    color: err ? red500 : (warn ? orange500 : grey500),
    borderColor: err ? red500 : (warn ? orange500 : grey300),
    borderBottomWidth: err || warn ? '2px' : '1px',
    errorText: err || warn,
    helperText: helperText
  };
  return (
    <div>
      <TextField
        hintText={label}
        floatingLabelText={label}
        floatingLabelFixed
        underlineStyle={{ borderColor: cProps.borderColor, borderBottomWidth: cProps.borderBottomWidth }}
        underlineFocusStyle={{ borderBottomWidth: '2px' }}
        floatingLabelStyle={{ color: cProps.color }}
        errorStyle={{ color: cProps.color }}
        errorText={cProps.errorText}
        style={{
          fontSize: '14px',
          ...style
        }}
        {...input}
        {...custom}
      />
      {!cProps.errorText && cProps.helperText && (
        <p
          style={{
            color: cProps.color,
            fontSize: '12px',
            lineHeight: '12px',
            marginTop: '-1px',
            marginBottom: 0
          }}
        >
          {cProps.helperText}
        </p>
      )}
    </div>
  );
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/basic/TextField.js